var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoDualSuspensionBikes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 740 547",
    y: "0px",
    x: "0px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "geo-diagram",
    "data-sanitized-baseprofile": "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guide-lines"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 472.61,
    x2: 624.8,
    y1: 364.28,
    x1: 624.8,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 472.61,
    x2: 115.21,
    y1: 382.14,
    x1: 115.21,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "605.15,356.53 508.02,141.69 619.33,331.12",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 355.17,
    x2: 319.14,
    y1: 81.56,
    x1: 217.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 340.48,
    x2: 123.54,
    y1: 340.48,
    x1: 597.52,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 88.73,
    x2: 298.67,
    y1: 300.24,
    x1: 298.67,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 352.47,
    x2: 292.9,
    y1: 197.56,
    x1: 259.55,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#B3B3B3",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "301.14,353.57 298.6,298.56 260.32,197.82",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#10C7E5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.87,234.66l208.15-126.34c4.51-1.9,9.71,0.15,11.71,4.62l10.16,22.78c1.96,4.4,0.11,5.56-4.19,7.71l-11.94,5.97 c-1.18,0.59-149.71,210.2-149.71,210.2l-30.03,4.08",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#10C7E5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 333.93,
    x2: 118.18,
    y1: 263.96,
    x1: 283.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#10C7E5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 10.71,
    cy: 363.69,
    cx: 300.31,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 8,
    stroke: "#10C7E5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 7.14,
    rx: 7.14,
    cy: 340.49,
    cx: 115.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 8,
    stroke: "#10C7E5",
    fill: "none",
    transform: "matrix(0.9806 -0.1961 0.1961 0.9806 -64.5314 29.2018)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.14,
    cy: 340.48,
    cx: 624.8,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 8,
    stroke: "#10C7E5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 344.64,
    x2: 122.94,
    y1: 362.5,
    x1: 289.59,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#10C7E5",
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "labels"
  }, /*#__PURE__*/React.createElement("g", {
    id: "geo-m"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "579.35,373.57  579.35,354.52 597.66,354.52",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "596.78,357.51 601.97,354.52 596.78,351.53",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 384.88,
    cx: 579.94,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.16,389.88l-0.03-5.3l-2.57,4.31h-1.26l-2.56-4.17v5.16h-2.61v-10h2.33l3.51,5.77l3.43-5.77h2.33 l0.03,10H583.16z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-l"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 473.06,
    x2: 373.03,
    y1: 182.14,
    x1: 373.03,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "370.04,183.01 373.03,177.83 376.03,183.01",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "370.04,472.19 373.03,477.37 376.03,472.19",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 427.37,
    cx: 373.03,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.24,422.37h2.83v7.76h4.77v2.24h-7.6L369.24,422.37L369.24,422.37z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-k"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 489.27,
    x2: 615.47,
    y1: 489.27,
    x1: 119.51,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "120.39,492.26 115.21,489.27 120.39,486.28",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "614.59,492.26 619.77,489.27 614.59,486.28",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    ry: 11.9,
    rx: 11.9,
    cy: 489.83,
    cx: 494.34,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.82,491.24l-1.06,1.13v2.5h-2.8v-10h2.8v4.15l3.87-4.16h3.11l-4.08,4.43l4.3,5.57h-3.29L493.82,491.24 z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-j"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 374.65,
    x2: 116.29,
    y1: 389.52,
    x1: 274.83,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "274.23,386.46 279.11,389.92 273.67,392.42",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "117.45,371.76 112,374.25 116.89,377.72",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 381.09,
    cx: 183.65,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86,385.81c-0.6-0.25-1.09-0.62-1.47-1.09l1.54-1.83c0.53,0.7,1.11,1.04,1.73,1.04 c0.41,0,0.72-0.12,0.94-0.37c0.21-0.25,0.32-0.61,0.32-1.09v-4.3h-3.46v-2.19h6.26v6.31c0,1.29-0.33,2.27-0.98,2.91 c-0.65,0.65-1.61,0.97-2.88,0.97C182.12,386.19,181.46,386.07,180.86,385.81z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-i"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 361.49,
    x2: 338.04,
    y1: 346.29,
    x1: 338.04,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "335.05,347.17 338.04,341.99 341.03,347.17",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "335.05,360.61 338.04,365.79 341.03,360.61",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 378.29,
    cx: 338.04,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.63,373.29h2.83v10h-2.83V373.29z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-h"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 473.06,
    x2: 300.9,
    y1: 388.83,
    x1: 300.9,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "297.91,389.7 300.9,384.52 303.89,389.7",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "297.91,472.19 300.9,477.37 303.89,472.19",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 439.87,
    cx: 300.9,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.66,434.87v10h-2.83v-3.9h-3.86v3.9h-2.83v-10h2.83v3.76h3.86v-3.76H305.66z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-g"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 57.17,
    x2: 475.58,
    y1: 57.17,
    x1: 229.22,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "230.09,60.17 224.91,57.17 230.09,54.18",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "474.7,60.17 479.88,57.17 474.7,54.18",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 57.17,
    cx: 340.78,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.02,56.96h2.5v4.14c-0.57,0.41-1.23,0.72-1.97,0.94c-0.74,0.22-1.49,0.33-2.23,0.33 c-1.05,0-1.99-0.22-2.83-0.66s-1.49-1.06-1.97-1.85c-0.48-0.79-0.71-1.69-0.71-2.69s0.24-1.89,0.71-2.69 c0.48-0.79,1.14-1.41,1.99-1.85c0.85-0.44,1.81-0.66,2.87-0.66c0.93,0,1.77,0.16,2.51,0.47s1.36,0.77,1.86,1.36l-1.8,1.63 c-0.68-0.74-1.49-1.11-2.43-1.11c-0.86,0-1.55,0.26-2.07,0.78c-0.52,0.52-0.79,1.21-0.79,2.08c0,0.55,0.12,1.05,0.36,1.48 s0.57,0.77,1,1.01c0.43,0.24,0.92,0.37,1.47,0.37c0.54,0,1.05-0.11,1.53-0.33L343.02,56.96L343.02,56.96z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-f"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 360.47,
    x2: 246.26,
    y1: 214.56,
    x1: 213.91,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "211.36,216.34 212.54,210.48 217.03,214.44",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "243.15,360.59 247.63,364.55 248.82,358.69",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 314.65,
    cx: 234.76,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.66,311.84v2.2h4.41v2.19h-4.41v3.43h-2.83v-10h7.84v2.19h-5.01V311.84z",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "geo-d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 131.89,
    x2: 536.66,
    y1: 88.59,
    x1: 517.52,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "515.14,90.6 515.78,84.65 520.61,88.18",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "533.57,132.3 538.4,135.83 539.04,129.88",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 110.24,
    cx: 527.09,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.19,104.4h4.73c1.1,0,2.07,0.21,2.91,0.61c0.85,0.41,1.51,0.99,1.97,1.74c0.47,0.75,0.7,1.63,0.7,2.64 s-0.23,1.89-0.7,2.64c-0.47,0.75-1.12,1.33-1.97,1.74c-0.85,0.41-1.82,0.61-2.91,0.61h-4.73V104.4z M526.81,112.14 c0.86,0,1.54-0.24,2.06-0.73c0.52-0.49,0.78-1.16,0.78-2.01s-0.26-1.53-0.78-2.01c-0.52-0.49-1.21-0.73-2.06-0.73h-1.79v5.48 C525.02,112.14,526.81,112.14,526.81,112.14z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-c"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 299.41,
    cx: 526.47,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.37,303.95c-0.83-0.44-1.49-1.06-1.96-1.85c-0.48-0.79-0.71-1.69-0.71-2.69s0.24-1.89,0.71-2.69 s1.13-1.41,1.96-1.85s1.77-0.66,2.82-0.66c0.91,0,1.74,0.16,2.47,0.49c0.73,0.32,1.34,0.79,1.83,1.4l-1.8,1.63 c-0.65-0.78-1.43-1.17-2.36-1.17c-0.54,0-1.03,0.12-1.45,0.36s-0.75,0.57-0.99,1.01c-0.23,0.43-0.35,0.93-0.35,1.49 s0.12,1.06,0.35,1.49s0.56,0.77,0.99,1.01c0.42,0.24,0.91,0.36,1.45,0.36c0.92,0,1.71-0.39,2.36-1.17l1.8,1.63 c-0.48,0.61-1.1,1.08-1.83,1.4c-0.73,0.32-1.56,0.49-2.47,0.49C526.14,304.61,525.2,304.39,524.37,303.95z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M546.03,326.91 c2.77-10.34,8.77-19.36,16.86-25.91",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "549.17,326.74 545.09,331.12 543.34,325.39",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "564,303.94 566.35,298.44 560.41,299.16",
    fill: "#5E5E5E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "geo-b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 85.74,
    x2: 476.34,
    y1: 85.74,
    x1: 307.21,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "308.08,88.73 302.9,85.74 308.08,82.75",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "475.46,88.73 480.64,85.74 475.46,82.75",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 85.74,
    cx: 402.68,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.95,86.46c0.32,0.42,0.49,0.94,0.49,1.54c0,0.88-0.35,1.55-1.06,2.03c-0.71,0.48-1.72,0.71-3.06,0.71 h-5.4v-10h5.11c1.28,0,2.25,0.24,2.91,0.71c0.67,0.47,1,1.11,1,1.91c0,0.48-0.12,0.9-0.35,1.28s-0.56,0.67-0.99,0.89 C406.18,85.73,406.62,86.04,406.95,86.46z M400.72,82.79v1.93h1.94c0.95,0,1.43-0.32,1.43-0.97c0-0.64-0.48-0.96-1.43-0.96H400.72 z M404.57,87.68c0-0.68-0.5-1.01-1.49-1.01h-2.37v2.03h2.37C404.08,88.7,404.57,88.36,404.57,87.68z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo-a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 102.19,
    x2: 324.52,
    y1: 343.31,
    x1: 324.52,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.51,342.44 324.52,347.62 321.53,342.44",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.51,103.07 324.52,97.88 321.53,103.07",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 265.32,
    cx: 324.52,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.61,268.38h-4.23l-0.79,1.94h-2.89l4.41-10h2.79l4.43,10h-2.94L326.61,268.38z M325.78,266.3 l-1.29-3.2l-1.29,3.2H325.78z",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "geo-e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 11.9,
    cy: 327.33,
    cx: 275.17,
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4,330.15v2.19h-8.03v-10h7.84v2.19h-5.04v1.69h4.44v2.11h-4.44v1.83L279.4,330.15L279.4,330.15z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M285.14,349.84 c3.37-7.9,9.26-14.47,16.67-18.7",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "288.3,350.1 283.67,353.88 282.71,347.98",
    fill: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "302.44,334.25 305.66,329.21 299.68,328.94",
    fill: "#5E5E5E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoDualSuspensionBikes);
export default __webpack_public_path__ + "static/media/geo-dual-suspension-bikes.107853841af1b2c65820a2e34d58d931.svg";
export { ForwardRef as ReactComponent };